import axios from 'axios'

export default {
	getAll(searchParams) {
		return axios.get(window.dtServerUrl + '/phonenumbers', {
			params: searchParams
		})
	},

	count(searchParams) {
		return axios.get(window.dtServerUrl + '/phonenumbers/count', {
			params: searchParams
		})
	},

	getById(id) {
		return axios.get(window.dtServerUrl + '/phonenumbers/' + id)
	},

	create(phoneNumber) {
		return axios.post(window.dtServerUrl + '/phonenumbers', phoneNumber).then((response) => {
			return response?.data
		})
	},

	update(phoneNumber) {
		return axios.put(window.dtServerUrl + '/phonenumbers/' + phoneNumber.id, phoneNumber).then((response) => {
			return response?.data
		})
	},

	delete(id) {
		return axios.delete(window.dtServerUrl + '/phonenumbers/' + id)
	},

	upload(file, tenantId) {
		const formData = new FormData()
		formData.append('file', file)
		formData.append('tenantId', tenantId)
		return axios.post(window.dtServerUrl + '/phonenumbers/upload', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
	}
}
